import { HistoryContent } from 'types';
import { formatTimestamp } from 'helpers';
import { monthName } from 'commons';

interface Props {
  content: HistoryContent[];
}

export function History({ content }: Props) {
  return (
    <div className="flex flex-col text-neutral-500">
      {content.map((entry) => {
        const { date: entryDay, entries: entryEntries } = entry;
        const { day, month, year } = formatTimestamp(entryDay);

        return (
          <div key={entryDay.toString()}>
            <div className="flex items-center gap-2">
              <div className="h-4 w-4 rounded-full bg-neutral-500" />

              <span className="text-font14 font-bold capitalize">
                {day} {monthName[month].short.toLowerCase()} {year}
              </span>
            </div>

            <div className="flex gap-2">
              <div className="relative flex min-w-4 flex-shrink justify-center">
                <div className="absolute -bottom-2.5 -top-2.5 min-w-0.5 bg-neutral-500" />
              </div>

              <div className="flex flex-col gap-4 py-4">
                {entryEntries.map((entryEntry) => {
                  const { date, content } = entryEntry;
                  const { hour, minute } = formatTimestamp(date);

                  return (
                    <div className="relative flex gap-2">
                      <div className="flex w-7justify-center">
                        <span className="sticky -top-4 h-3 text-font12">
                          {hour}:{minute}
                        </span>
                      </div>

                      {content}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
